<div #mapContainer class="map-container drivers-map h-full border-round-bottom-lg overflow-hidden">
  <div class="custom-goole-map google-map" #mapDiv style="width: 100%; height: 500px;"> </div>

  <div class="map-legend-container">
    <div
      class="map-legend flex flex-column py-spacing-md px-spacing-xl text-inverse-bg gap-spacing-xs border-round-lg border-1 border-brand-lighter-border">
      <div class="item flex gap-spacing-md">
        <span class="dot success"></span>
        <span class="body-medium-regular text-primary-color">Ride Best Match Drivers</span>
      </div>
      <div class="item flex gap-spacing-md">
        <span class="dot warning"></span>
        <span class="body-medium-regular text-primary-color">Ride Partially Match Driver</span>
      </div>
      <div class="item flex gap-spacing-md">
        <span class="dot danger"></span>
        <span class="body-medium-regular text-primary-color">Ride Least Match Driver</span>
      </div>
    </div>
  </div>
</div>
